import { useGetChartNewsMarkersQuery } from "~/feature/chart/chartApi";
import type { IChartSelection } from "~/feature/chart/types";
import { buildChartRequest } from "~/feature/chart/utils";
import { useBackgroundError } from "~/hooks/useBackgroundError";

export const useChartNews = (selection: IChartSelection) => {
  const { params, options } = buildChartRequest(selection);
  const { data, isUninitialized, isLoading, isFetching, error } =
    useGetChartNewsMarkersQuery(params, options);

  useBackgroundError(error);

  return {
    news: data ?? [],
    isNewsLoading: (isUninitialized || isLoading || isFetching) && !data,
  };
};
